import { render, staticRenderFns } from "./prebj.vue?vue&type=template&id=35f97ebe&scoped=true"
import script from "./prebj.vue?vue&type=script&lang=js"
export * from "./prebj.vue?vue&type=script&lang=js"
import style0 from "./prebj.vue?vue&type=style&index=0&id=35f97ebe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f97ebe",
  null
  
)

export default component.exports